import { useQuery } from "react-query";
import { request } from "../Utils/axios";
import { consolelog } from "../Utils/consolelog";

export const apiConnect = (skip: number, take: number,
    service: string, filter?: string): Promise<any> => {
    let urlStub: string = `api/${service}`;
    if (take > 0) {
        urlStub += `?$skip=${skip}&$top=${take}`;
    }

    if (filter !== "" && filter !== undefined) {
        urlStub += `&$filter=${filter}`;
    }

    return request({ url: urlStub }).then((res) => res);
}


export const useHookForApi = (onSuccess: any, onError: any,
    skip: number, take: number, service: string,
    filter?: string, depedentValue?: boolean) => {
    return useQuery<any, Error>([`${service}-data`, skip, take, filter], () => apiConnect(skip, take, service, filter), {
        onSuccess,
        onError,
        select: (data) => {
            consolelog('Rajesh', data)
            const response = data;
            return response
        },
        enabled: depedentValue,
    })
}